import { FETCH_AVISOS, GET_AVISOS } from "../actions/types.js";

const initialState = {
  avisos: [],
  isLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_AVISOS:
      return {
        ...state,
        avisos: [],
        isLoading: true,
      };
    case GET_AVISOS:
      return {
        ...state,
        avisos: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
}
